import {
    DialogContent,
    TextField,
    Divider,
    DialogActions,
    Button,
    styled,
} from '@mui/material';
import DashboardItemWrapper from 'components/DashboardItemWrapper/DashboardItemWrapper';
import DashboardsModalWrapper from 'components/DashboardsModalWrapper/DashboardsModalWrapper';
import React, { useState, ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { SupportDashboardT } from 'routes/Support/models';

const StyDashboardItemButton = styled('div', {
    name: 'StyDashboardItemWrapper',
})({
    '&:hover': {
        cursor: 'pointer',
    },
});

const DashboardSelectionItemModal = <T extends { title: string }>({
    dashboard,
    onClick,
}: {
    dashboard: T;
    onClick: (slug: string) => void;
}) => {
    return (
        // @ts-expect-error onClick is an HTML Div event handler, it shouldn't take a string as arg
        <DashboardItemWrapper dataTitle={dashboard.title} onClick={onClick}>
            <StyDashboardItemButton className="dashboard-title" role="button">
                {dashboard.title}
            </StyDashboardItemButton>
        </DashboardItemWrapper>
    );
};

const DashboardSelectionModal = ({
    open,
    onClose,
    dashboards,
    onClick,
}: {
    open: boolean;
    onClose: () => void;
    onClick: (slug: string | null) => void;
    dashboards: SupportDashboardT[];
}) => {
    const [filter, setFilter] = useState('');
    const { t } = useTranslation();
    const onFilterChange = (e: ChangeEvent<HTMLInputElement>): void =>
        setFilter(e.target.value);

    const filteredDashboards = dashboards
        .filter((dashboard) => dashboard.isSharedToOrganisation)
        .filter(
            (dashboard) =>
                !filter ||
                dashboard.title.toLowerCase().includes(filter.toLowerCase()),
        )
        .sort((a, b) => a.title.localeCompare(b.title));
    return (
        <DashboardsModalWrapper open={open} onClose={onClose}>
            <DialogContent>
                <TextField
                    value={filter}
                    autoFocus
                    variant="outlined"
                    margin="dense"
                    size="small"
                    fullWidth
                    label={t('home.searchDashboard')}
                    onChange={onFilterChange}
                />
                <DashboardSelectionItemModal
                    key="default"
                    dashboard={{
                        title: t(
                            'support.decisionConfiguration.decisionHomePage.defaultHomePage',
                        ),
                    }}
                    onClick={() => {
                        onClick(null);
                        onClose();
                    }}
                />
                <Divider />
                {filteredDashboards.map((dashboard) => (
                    <DashboardSelectionItemModal
                        key={dashboard.slug}
                        dashboard={dashboard}
                        onClick={() => {
                            onClick(dashboard.slug);
                            onClose();
                        }}
                    />
                ))}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>{t('common.close')}</Button>
            </DialogActions>
        </DashboardsModalWrapper>
    );
};

export default DashboardSelectionModal;
